var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileNormalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17,
    stroke: "#209AA0",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70576 23.5548C5.01067 21.7952 4.686 19.9112 4.75205 18.0204C4.8181 16.1296 5.27345 14.2728 6.08963 12.566C6.90582 10.8592 8.0653 9.33912 9.49559 8.10073C10.9259 6.86235 12.5963 5.93231 14.4023 5.36874C16.2083 4.80518 18.1112 4.6202 19.9919 4.82537C21.8727 5.03054 23.6909 5.62146 25.3329 6.56117C26.9749 7.50089 28.4055 8.76922 29.5351 10.2869C30.6648 11.8045 31.4692 13.5389 31.8982 15.3815L22.7691 21.3461L15.1794 17.5512L5.70576 23.5548Z",
    fill: "#209AA0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNormalLogo);
export default __webpack_public_path__ + "static/media/mobile-normal-logo.badd6e0ddccc99b9fda7c89e1a2bb391.svg";
export { ForwardRef as ReactComponent };